<div class="{{partnerName}}">
    <div class="product-top-section" id="product-top-section">
        <thc-cbd-cards [partnerName]="partnerName" [selectedGroup]="secTwoQuestOneGroup" (onSelectGroup)="selectGroup($event)"></thc-cbd-cards>
        <div class="product-block">
            <div class="product-search-block">
                <div class="product-search">
                    <label>Produzent</label>
                    <div class="autocomplete position-relative">
                        <input type="text" class="form-control" [(ngModel)]="producerName" (keyup)="keyupProducerName($event)" (change)="filterBatchGrid()" placeholder="Produzent" list="producer-type-list">
                        <datalist class="scrollbar" id="producer-type-list">
                            <ng-container *ngFor="let producerName of producerNameList">
                                <option [value]="producerName" (click)="chooseProducerName(producerName)">{{producerName}}</option>
                            </ng-container>
                        </datalist>
                        <!--<input type="text" [(ngModel)]="productName" id="search-batch-data" class="form-control" placeholder="Product Name" (keyup)="filterBatchGrid()" (change)="filterBatchGrid()" />-->
                    </div>
                </div>
                <div class="product-search">
                    <label>Cultivar</label>
                    <select class="form-control" [(ngModel)]="strain" (change)="filterBatchGrid()">
                        <option value="">Alle</option>
                        <ng-container *ngFor="let item of strainList">
                            <option [value]="item">{{item}}</option>
                        </ng-container>
                    </select>
                </div>
            </div>
            <div class="product-search-block">
                <div class="product-search">
                    <label>Produkt Kategorie</label>
                    <div class="input-buttons">
                        <ng-container *ngFor="let item of productTypeList">
                            <button type="button" class="input-button" [class.selected]="productTypes.indexOf(item)>-1" (click)="selectProductType(item)">
                                <span>{{item}}</span>
                            </button>
                        </ng-container>
                    </div>
                </div>
                <div class="product-search">
                    <label>Dominanz</label>
                    <div class="input-buttons">
                        <button type="button" class="input-button" [class.selected]="strainFamilies.length===strainFamilyList.length" (click)="selectAllStrainFamily()">
                            <span>Alle</span>
                        </button>
                        <ng-container *ngFor="let item of strainFamilyList">
                            <button type="button" class="input-button" [class.selected]="strainFamilies.indexOf(item)>-1" (click)="selectStrainFamily(item)">
                                <span>{{item}}</span>
                            </button>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div class="product-slider-container">
                <div class="product-slider-block">
                    <label class="mb-1">THC Konzentration</label>
                    <!--<div class="graph-block thc-diagram">
                        <div id="thcDiagram"></div>
                    </div>-->
                    <div class="slider-block">
                        <div>{{minTHC}}</div>
                        <range-slider #rangeSliderTHC [min]="minTHC" [max]="maxTHC" [step]="rangeStep" [(ngModel)]="thcRange" (onRangeChange)="sliderValueChanges($event)"></range-slider>
                        <div>{{maxTHC}}</div>
                    </div>
                </div>
                <div class="product-slider-block">
                    <label class="mb-1">CBD Konzentration</label>
                    <!--<div class="graph-block cbd-diagram">
                        <div id="cbdDiagram"></div>
                    </div>-->
                    <div class="slider-block">
                        <div>{{minCBD}}</div>
                        <range-slider #rangeSliderCBD [min]="minCBD" [max]="maxCBD" [step]="rangeStep" [(ngModel)]="cbdRange" (onRangeChange)="sliderValueChanges($event)"></range-slider>
                        <div>{{maxCBD}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="product-tab-section">
        <ul>
            <li [class.active]="activeTab==='TABLE'" (click)="changeTab('TABLE')">Tabelle</li>
            <li [class.active]="activeTab==='DIAGRAM'" (click)="changeTab('DIAGRAM')">Diagramm</li>
        </ul>
    </div>
    <div class="product-content-section">
        <div class="product-grid" *ngIf="activeTab==='TABLE'">
            <div id="productGrid"></div>
        </div>
        <div class="product-diagram scrollbar-white" *ngIf="activeTab==='DIAGRAM'">
            <div class="diagram-slider">
                <label>Kollisionsvermeidungsfaktor</label>
                <ngx-slider [(value)]="sliderValue" [options]="sliderOptions" (valueChange)="forceSimulation()"></ngx-slider>
            </div>
            <div id="productDiagram"></div>
        </div>
    </div>
</div>
